export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7468.b81b579f.jpg";